import { render, staticRenderFns } from "./siderNetwork.vue?vue&type=template&id=31084201&scoped=true&"
import script from "./siderNetwork.vue?vue&type=script&lang=js&"
export * from "./siderNetwork.vue?vue&type=script&lang=js&"
import style0 from "./siderNetwork.vue?vue&type=style&index=0&id=31084201&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31084201",
  null
  
)

export default component.exports